import React from "react";

// Mystical brand mark: crescent moon + lotus in fine gold linework
export const Logo = ({ className = "", size = 36 }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 100 100"
    fill="none"
    className={className}
    aria-hidden="true"
  >
    {/* crescent moon */}
    <path
      d="M64 20 a30 30 0 1 0 0 60 a24 24 0 1 1 0 -60 Z"
      stroke="currentColor"
      strokeWidth="1.6"
      fill="none"
      opacity="0.9"
    />
    {/* lotus petals */}
    <g stroke="currentColor" strokeWidth="1.4" fill="none" opacity="0.95">
      <path d="M50 78 C50 66 50 60 50 54" />
      <path d="M50 62 C42 62 36 58 33 52 C40 51 46 53 50 58" />
      <path d="M50 62 C58 62 64 58 67 52 C60 51 54 53 50 58" />
      <path d="M50 60 C44 56 40 50 40 43 C46 46 50 51 50 57" />
      <path d="M50 60 C56 56 60 50 60 43 C54 46 50 51 50 57" />
    </g>
    {/* small stars */}
    <g fill="currentColor" opacity="0.85">
      <circle cx="30" cy="30" r="1.1" />
      <circle cx="74" cy="66" r="1.1" />
      <circle cx="24" cy="60" r="0.8" />
    </g>
  </svg>
);

export default Logo;
